import type { QuestionnaireResponse, Reference } from '@medplum/fhirtypes'
import { formatDate } from '@seen/core/dates'
import { ValidatedToolResponse } from '@seen/core/models/validatedToolResponse'
import { IconClipboardCheck } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useRead } from '#src/hooks/useRead.ts'

export function ValidatedToolResponseOption({
  validatedToolResponse,
}: {
  validatedToolResponse: Reference<QuestionnaireResponse>
}): JSX.Element {
  const { data: instance } = useRead(
    ValidatedToolResponse,
    validatedToolResponse
  )
  return (
    <div className="flex items-center gap-2">
      <div className="p-0.5">
        <IconClipboardCheck className="size-4 shrink-0" />
      </div>
      <span>
        {instance?.name}
        {instance && (
          <span className="text-muted-foreground">
            {' '}
            {instance.displayText && <>: {instance.displayText} </>}·{' '}
            {formatDate(instance.authored)}
          </span>
        )}
      </span>
    </div>
  )
}
